<style>
  .vue-daterange-picker .ranges {
    float: left;
  }
</style>
<template>
  <div id="demo-basic-card">
    <div id="dashboard-analytics">

      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <div class="vx-row">
            <div class="vx-col w-full mb-base">
              <vx-card slot="no-body" style="min-height: 1000px;">
                <div class="vx-row">
                  <div class="vx-col w-full" style="margin-bottom: 15px">
                    <div class="vx-row">
                      <div class="vx-col mt-5 marginLeft">
                        <span><b>Thời gian: </b></span>
                      </div>
                      <div class="vx-col md:w-1/6 mt-2">
                        <date-range-picker
                          ref="picker"
                          :locale-data="{format: 'dd/mm/yyyy' }"
                          :open="'left'"
                          @update="updateValues"
                          v-model="dateRange">
                        </date-range-picker>
                      </div>
                      <div class="vx-col md:w-1/6 mt-2">
                        
                      </div>
                      <div class="vx-col md:w-1/2 w-full mt-2" style="margin-left: 8%">
                        <vs-button style="float: right;"
                                   @click="downloadFile"
                                   color="primary"
                                   type="border"
                                   icon-pack="feather"
                                   icon="DownloadIcon">
                          Tạo báo cáo
                        </vs-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-row mt-5">
                  <div class="vx-col w-full lg:w-2/3 mb-base">
                    <vx-card slot="no-body" style="max-height: 380px; min-height: 380px">
                      <H2 class="mb-5"><b>Biến động</b></H2>
                      <vue-apex-charts v-if="showSourceDataChartLine"
                                       id="source-data"
                                       type=line
                                       height=266
                                       :options="sourceDataChartLine.chartOptions"
                                       :series="sourceDataChartLine.series"/>
                    </vx-card>
                  </div>
                  <div class="vx-col w-full lg:w-1/3 mb-base">
                    <vx-card slot="no-body" style="max-height: 380px; min-height: 380px">
                      <h3><b>Cần quan tâm</b></h3>
                      <div class="vx-row ml-16">
                        <h1 class="header-title title">
                          {{topicFocus ? topicFocus.topicName : ""}}</h1>
                        <span class="title feather-icon select-none relative ml-2"><svg
                          xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 0 24 24"
                          :fill="topicFocus ? topicFocus.color : '' " stroke="none" stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12"
                                                                                                 r="10"></circle></svg></span>
                      </div>
                      <div class="vx-row ml-16 lg:w-2/3 mb-base">
                        <p>Từ khóa: <b>{{topicFocus ? topicFocus.keywordsView : ''}}</b></p>
                      </div>
                      <div class="vx-row ml-16 mt-5">
                        <span style="font-size: 16px">Nhắc đến</span>
                      </div>
                      <div class="vx-row  ml-16">
                        <h1 class="color-data">{{topicFocus && topicFocus.countMention ?
                          topicFocus.countMention.toLocaleString() : 0}}</h1>
                        <div class="vx-row color-green"
                             v-if="topicFocus && topicFocus.increase && topicFocus.percent != 0">
                          <span class="percent" style="margin-left: 20px;">{{topicFocus ? topicFocus.percent : ''}}</span>
                          <span class="percent">%</span>
                          <feather-icon style="margin-left: 5px; margin-top: 10px" svgClasses="w-4 h-4" icon="TrendingUpIcon"></feather-icon>
                        </div>
                        <div class="vx-row reduction"
                             v-if="topicFocus && !topicFocus.increase && topicFocus.percent != 0">
                          <span class="percent" style="margin-left: 20px;">{{topicFocus ? topicFocus.percent : ''}}</span>
                          <span class="percent">%</span>
                          <feather-icon style="margin-left: 5px; margin-top: 10px" svgClasses="w-4 h-4" icon="TrendingDownIcon"></feather-icon>
                        </div>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="#5EE581" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Tích cực: <b style="color: #2c2c2c; margin-left: 5px">{{topicFocus && topicFocus.totalPositive ? topicFocus.totalPositive.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="#f4b401" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Trung lập: <b style="color: #2c2c2c; margin-left: 5px">{{topicFocus && topicFocus.totalNeutral ? topicFocus.totalNeutral.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="red"
                          stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Tiêu cực: <b style="color: #2c2c2c; margin-left: 5px">{{topicFocus && topicFocus.totalNegative ? topicFocus.totalNegative.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row ml-16 mt-5">
                        <vs-button style="background: rgba(51,102,255,0.85) !important; border-radius: 20px;"
                                   @click="openArticleTopic(topicFocus.topicId)">Xem Thêm
                        </vs-button>
                      </div>
                    </vx-card>
                  </div>

                </div>

                <H2 class="mb-5"><b>Tất cả chủ đề</b></H2>
                <div class="vx-row">
                  <div class="vx-col w-full lg:w-1/3 mb-base" v-for="(topic,index) in mention">
                    <vx-card slot="no-body" style="max-height: 380px; min-height: 380px">
                      <div class="vx-row ml-16">
                          <h1 class="header-title title text-1">
                            {{topic.topicName}}</h1>
                          <span class="title feather-icon select-none relative ml-2"><svg
                            xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 0 24 24"
                            :fill="topic.color" stroke="none" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-circle h-6 w-6"><circle cx="12" cy="12"
                                                                                                   r="10"></circle></svg></span>
                      </div>
                      <div class="vx-row ml-16 lg:w-2/3 mb-base text-1">
                        <p>Từ khóa: <b>{{topic.keywordsView}}</b></p>
                      </div>
                      <div class="vx-row ml-16 mt-5">
                        <span style="font-size: 16px">Nhắc đến</span>
                      </div>
                      <div class="vx-row  ml-16">
                        <h1 class="color-data">{{topic.countMention.toLocaleString()}}</h1>
                        <div class="vx-row color-green" v-if="topic.increase && topic.percent != 0">
                          <span class="percent" style="margin-left: 20px;">{{topic.percent}}</span>
                          <span class="percent">%</span>
                          <feather-icon style="margin-left: 5px; margin-top: 10px" svgClasses="w-4 h-4" icon="TrendingUpIcon"></feather-icon>
                        </div>
                        <div class="vx-row reduction" v-if="!topic.increase && topic.percent != 0">
                          <span class="percent" style="margin-left: 20px;">{{topic.percent}}</span>
                          <span class="percent">%</span>
                          <feather-icon style="margin-left: 5px; margin-top: 10px" svgClasses="w-4 h-4"icon="TrendingDownIcon"></feather-icon>
                        </div>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="#5EE581" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Tích cực: <b style="color: #2c2c2c; margin-left: 5px">{{topic.totalPositive ? topic.totalPositive.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"
                          fill="#f4b401" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Trung lập: <b style="color: #2c2c2c; margin-left: 5px">{{topic.totalNeutral ? topic.totalNeutral.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row">
                        <span class="title feather-icon select-none relative ml-24"><svg
                          xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="red"
                          stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="feather feather-circle h-6 w-6"><circle cx="12" cy="12" r="10"></circle></svg></span>
                        <span style="font-size: 16px">Tiêu cực: <b style="color: #2c2c2c; margin-left: 5px">{{topic.totalNegative ? topic.totalNegative.toLocaleString() : 0}}</b></span>
                      </div>
                      <div class="vx-row ml-16 mt-10">
                        <vs-button style="background: rgba(51,102,255,0.85) !important; border-radius: 20px;"
                                   @click="openArticleTopic(topic.topicId)">Xem Thêm
                        </vs-button>
                      </div>
                    </vx-card>

                  </div>
                </div>
              </vx-card>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import moment from "moment";
  import Datepicker from 'vuejs-datepicker';
  import VueApexCharts from 'vue-apexcharts';
  import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  export default {
    name: 'app', data() {
      return {
        topicFocus: null,
        dateRange: {
          endDate: new Date(),
          startDate: (() => { let date = new Date ();
            date.setDate(date.getDate() - 6);
            date.setHours(0,0,0);
            return date 
          })()
        },
        showSourceDataChartLine: false,
        sourceDataChartLine: {
          series: [],
          chartOptions: {
            chart: {
              redrawOnParentResize: true,
              toolbar: {show: false},
              dropShadow: {
                enabled: true,
                opacity: 0.10,
              },
            },
            stroke: {
              curve: 'smooth',
              //dashArray: [0, 8],
              width: [2, 2, 2, 2, 2, 2, 2, 2, 2,
                2, 2, 2, 2, 2, 2, 2, 2
                , 2, 2, 2, 2, 2, 2, 2, 2],
            },
            grid: {
              borderColor: '#e7e7e7',
            },
            legend: {
              show: true,
            },
            colors: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
              '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
              '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
              '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
              '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
              '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
              '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
              '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
              '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
              '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
            fill: {
              type: 'gradient',
              gradient: {
                shade: 'dark',
                inverseColors: false,
                gradientToColors: ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
                  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
                  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
                  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
                  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
                  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
              },
            },
            markers: {
              size: 0,
              hover: {
                size: 5
              }
            },
            xaxis: {
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                }
              },
              axisTicks: {
                show: false,
              },
              categories: [],
            },
            yaxis: {
              tickAmount: 5,
              labels: {
                style: {
                  cssClass: 'text-grey fill-current',
                },
                formatter: function (val) {
                  return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                }
              }
            },
            tooltip: {
              x: {show: false}
            }
          }
        },
        increaseSocial: true,
        colorDefault: "rgba(51,102,255,0.85)",
        colorSocial: "",
        colorNews: "",
        colorOther: "",
        to: new Date(),
        from: (() => { let date = new Date ();
          date.setDate(date.getDate() - 7);
          date.setHours(0,0,0);
          return date })(),
        mention: {},

      }
    },
    components: {
      VuePerfectScrollbar,
      Datepicker,
      VueApexCharts,
      DateRangePicker
    },
    computed: {},
    mounted() {
    },
    async created() {
      this.initScreen();
    },
    methods: {
      openArticleTopic: function (topicId) {
        this.$router.push(`/user/article-topic-details?id=${topicId}`).catch(() => {
        });
      },
      initScreen() {

        this.from = this.dateRange.startDate
        this.to = this.dateRange.endDate
        this.getMention();
        this.getSourceDataTopicByDay();
      },
      formatDate(val) {
        return moment(val).format("DD/MM/YYYY");
      },
      updateValues() {
        this.initScreen();
      },

      getSourceDataTopicByDay() {
        let conditions = {
          to: this.to,
          from: this.from
        };

        let that = this;
        that.showSourceDataChartLine = false;
        that.sourceDataChartLine.series = [];
        this.$vs.loading();
        this.$processor.post('/user-data/get-source-data-topic-by-day', conditions).then((topics) => {
          topics.data.forEach((topic, index) => {
            that.sourceDataChartLine.chartOptions.xaxis.categories = [];
            that.sourceDataChartLine.chartOptions.xaxis.categories.push(...topic.sourceDataTopicByDay.map(x => {
              return x.stringDate.slice(6, 8) + "/" + x.stringDate.slice(4, 6) + "/" + x.stringDate.slice(0, 4)
            }));
            that.sourceDataChartLine.series.push({
              name: topic.topicName,
              data: topic.sourceDataTopicByDay.map(x => {
                return x.totalData
              })
            });
            that.showSourceDataChartLine = true;
            })
        });
      },
      getMention() {
        let conditions = {
          to: this.to,
          from: this.from
        };
        this.$vs.loading();
        this.$processor.post('/user-data/get-mention-topic', conditions).then((mention) => {
          if (mention.data) {
            mention.data.forEach((topic) => {
              topic.keywordsView = topic.keywords.map((elements) => {
                return elements.keyword;
              }).join(", ");

              topic.color = "#fff";
              if(topic.countMention != 0) {
                if (topic.totalPositive > topic.totalNegative) {
                  topic.color = "#5EE581"
                  if (topic.totalPositive < topic.totalNeutral) topic.color = "#f4b401"
                } else {
                  topic.color = "red"
                  if (topic.totalNegative < topic.totalNeutral) topic.color = "#f4b401"
                }
              }



              topic.increase = null;
              topic.percent = 0;
              if (topic.totalFrom < topic.totalTo) {
                topic.increase = true;
                topic.percent = "+" + (((topic.totalTo - topic.totalFrom) / (topic.totalFrom ? topic.totalFrom : 1)) * 100).toFixed(2);
              } else {
                topic.increase = false;
                topic.percent = "-" + (((topic.totalFrom - topic.totalTo) / (topic.totalTo ? topic.totalTo : 1)) * 100).toFixed(2);
              }

              if (!this.topicFocus || topic.countMention > this.topicFocus.countMention) {
                this.topicFocus = topic;
              }
            })
          }
          this.mention = mention.data;
          this.$vs.loading.close();
        }).catch((err) => {
        });
      },
      downloadFile() {
      },
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/components/vxCard.scss";

  #dashboard-analytics {
    .greet-user {
      position: relative;

      .decore-left {
        position: absolute;
        left: 0;
        top: 0;
      }

      .decore-right {
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    @media(max-width: 576px) {
      .decore-left, .decore-right {
        width: 140px;
      }
    }
  }

  .text-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
  }

  .color-blue {
    color: #3366ff;
    font-size: 50px;
    font-weight: bold
  }

  .color-data {
    font-size: 50px;
    font-weight: bold
  }

  .color-green {
    color: #5EE581
  }

  .color-red {
    color: red;
  }

  .header-title {
    color: rgba(51,102,255,0.85);
    font-size: 30px;
    max-width: 80%;
    font-weight: bold;
    font-size: 25px;
  }

  .increase {
    color: #5EE581
  }

  .reduction {
    color: red;
  }

  .medium {
    color: #f4b401;
  }

  .all-top-pic {
    font-size: 16px;
  }

  .title {
    float: left;
    margin-right: 10px;
  }

  .percent {
    margin-top: 25px;
    font-size: 15px;
  }
</style>
